import i18n, { languageResources } from 'translations/i18n'

import { Language } from 'translations/Language'
import moment from 'moment'
import momentTZ from 'moment-timezone'

/**
 * Apply a language change: update i18n, moment locales, and localStorage.
 */
export function applyLanguageChange(language: Language) {
  const lowerCaseLanguage = language.toLowerCase()
  if (!Object.keys(languageResources).includes(lowerCaseLanguage)) return

  const storedLanguage = localStorage.getItem('i18nextLng')
  if (storedLanguage !== lowerCaseLanguage) localStorage.setItem('i18nextLng', lowerCaseLanguage)

  if (i18n.language === lowerCaseLanguage) return
  i18n.changeLanguage(lowerCaseLanguage)
  moment.locale(lowerCaseLanguage)
  momentTZ.locale(lowerCaseLanguage)
}

/**
 * Detect language from userMe data and apply if different from current.
 */
export function applyLanguageFromUserMe(userLanguage?: string) {
  if (!userLanguage) return

  const refinedLanguage: Language | undefined = Language[userLanguage.toUpperCase() as Language]
  if (!refinedLanguage) return

  if (i18n.language === refinedLanguage.toLowerCase()) return

  applyLanguageChange(refinedLanguage)
}
